import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Router, ActivatedRoute } from '@angular/router';
import { ProjectService } from '../project.service';
import { RoomService } from '../room.service';
import { SnackbarService } from 'src/app/snackbar/service/snackbar.service';
import { MatDialog } from '@angular/material/dialog';
import { Project } from 'src/app/entity/project';
import { Room } from 'src/app/entity/room';

@Component({
  selector: 'app-room-detail-view',
  templateUrl: './room-detail-view.component.html',
  styleUrls: ['./room-detail-view.component.scss'],
})
export class RoomDetailViewComponent implements OnInit {
  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private roomService: RoomService,
    private snackbarService: SnackbarService,
    public dialog: MatDialog
  ) {}

  projectId: number;
  activeRoomId: number;

  project: Project;
  activeRoom: Room;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  ngOnInit(): void {
    this.route.paramMap.subscribe((paramMap) => {
      this.projectId = Number(paramMap.get('projectId'));
      this.activeRoomId = Number(paramMap.get('roomId'));

      this.projectService.getProjectById(this.projectId).subscribe((res) => {
        this.project = res;
        // this.carouselTileItems$ = this.getLicences();
      });
      this.roomService.getRoomById(this.activeRoomId).subscribe((res) => {
        this.activeRoom = res;
      });
    });
  }
}
